var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLlIconFullHeightLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276.93,
    height: 43.679,
    viewBox: "0 0 276.93 43.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(44 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M191.2,22.65h-6.48c-.01-.23-.01-21.99-.01-21.99V0h5.28l.47.48s6.33,7.34,9.5,11.01c.14.16.28.32.55.62V.07h6.47V22.68h-5.33s-6.71-7.52-9.88-11.08c-.14-.16-.54-.58-.54-.58l-.03,11.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M139.7.02V5.47H128.32V8.84h10.43v4.97c-.24,0-10.43-.09-10.43-.09v3.54h11.49v5.42l-17.99.04S121.81.75,121.81.01c0,0,17.63-.01,17.89,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M232.81.02V5.47H221.43V8.84h10.43v4.97c-.24,0-10.43-.09-10.43-.09v3.54h11.49v5.42l-17.99.04S214.92.75,214.92.01c0,0,17.63-.01,17.89,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M90.72.02h7.27l.22.54s3.29,8.14,4.94,12.21c.09.22.19.43.34.78.14-.32.25-.51.33-.72C105.46,8.76,108.74.61,108.74.61l.27-.59s6.9-.02,7.15,0c-.16.4-.3.78-.44,1.11-2.92,6.97-8.76,20.92-9.08,21.56h-6.32S90.78.23,90.72.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M153.83.02l-.03,17.1h10.7v5.52H147.34v-.66c0-7.09-.01-21.28-.01-21.96,0,0,6.26-.01,6.51,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M62.06,17.14H72.74v5.51c-.23.01-.46.03-.68.03-5.24,0-16.46-.02-16.46-.02L55.48,0h6.59s-.01,16.78-.01,17.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M85.17,22.64H78.74c0-7.76-.01-22.63-.01-22.63s6.22-.01,6.46,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M170.54,0c.21-.02,5.82,0,6.41,0V22.62h-6.42L170.55,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M28.139,21.893l12.455,12.34-4.728,4.594-7.919-7.535L15.819,43.67,0,27.966,28.351,0,62.7,34.348,81.593,15.569,75.327,9.687,62.949,21.816,50.3,9.687l4.844-4.728,7.4,7.285L75.346,0,91.184,15.7,62.833,43.67,28.216,9.207,9.457,28.1l6.131,6.266L28.159,21.912Z",
    transform: "translate(-44)",
    fill: "#eeb211"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M59.11,32.99H55.36v-2.4H65.59v2.4H61.86V43.41H59.11V32.99Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M70.16,30.59h9.07v2.35H72.89v2.79H79.1v2.35H72.89v2.98h6.34v2.36H70.16V30.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M83.83,37.01a6.49,6.49,0,0,1,6.73-6.63,5.923,5.923,0,0,1,5.46,3.13l-2.35,1.15a3.511,3.511,0,0,0-3.11-1.87A3.974,3.974,0,0,0,86.64,37a3.974,3.974,0,0,0,3.92,4.21,3.462,3.462,0,0,0,3.11-1.87l2.35,1.14a5.959,5.959,0,0,1-5.46,3.15A6.49,6.49,0,0,1,83.83,37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M109.53,38.03h-6.06v5.38h-2.73V30.59h2.73v5.04h6.06V30.59h2.75V43.41h-2.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M120.72,34.8v8.61h-2.73V30.59h2.81l5.94,8.3v-8.3h2.73V43.41h-2.63l-6.11-8.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M141.22,30.38a6.446,6.446,0,0,1,6.71,6.63,6.7,6.7,0,0,1-13.4,0,6.441,6.441,0,0,1,6.69-6.63Zm0,2.42c-2.36,0-3.88,1.81-3.88,4.21s1.52,4.21,3.88,4.21a3.905,3.905,0,0,0,3.9-4.21A3.905,3.905,0,0,0,141.22,32.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M152.97,30.59h2.73V41.01h5.42v2.4h-8.15V30.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M171.62,30.38a6.446,6.446,0,0,1,6.71,6.63,6.7,6.7,0,0,1-13.4,0,6.441,6.441,0,0,1,6.69-6.63Zm0,2.42c-2.36,0-3.88,1.81-3.88,4.21s1.52,4.21,3.88,4.21a3.905,3.905,0,0,0,3.9-4.21A3.905,3.905,0,0,0,171.62,32.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M189.51,30.38a6.016,6.016,0,0,1,5.31,2.81l-2.27,1.23a3.647,3.647,0,0,0-3.04-1.61,3.994,3.994,0,0,0-4.02,4.21,3.994,3.994,0,0,0,4.02,4.21,4.347,4.347,0,0,0,2.77-.98V38.69h-3.42V36.35h6.11v4.9a7.118,7.118,0,0,1-5.46,2.42,6.642,6.642,0,1,1,0-13.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M200.39,30.59h2.73V43.41h-2.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M208.81,30.59h9.07v2.35h-6.34v2.79h6.21v2.35h-6.21v2.98h6.34v2.36h-9.07V30.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M223.85,39.53a5.632,5.632,0,0,0,4.08,1.73c1.5,0,2.23-.71,2.23-1.44,0-.96-1.12-1.29-2.6-1.64-2.1-.48-4.79-1.06-4.79-3.92,0-2.13,1.85-3.86,4.86-3.86a7.149,7.149,0,0,1,5,1.79l-1.52,2a5.471,5.471,0,0,0-3.67-1.4c-1.25,0-1.88.54-1.88,1.31,0,.87,1.08,1.14,2.56,1.48,2.11.48,4.81,1.12,4.81,3.96,0,2.34-1.67,4.11-5.13,4.11a7.309,7.309,0,0,1-5.42-2.04l1.48-2.08Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlIconFullHeightLogo);
export default __webpack_public_path__ + "static/media/ll_icon_full_height_logo.0a1af910e187d51362df7276dbaf820e.svg";
export { ForwardRef as ReactComponent };